"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GenericRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _right_arrow = _interopRequireDefault(require("../../../asset/icons/right_arrow.svg"));

var _GenericSubRow = _interopRequireDefault(require("./GenericSubRow"));

var _RowComponents = require("./RowComponents");

var _GreenCheckbox = require("../../CheckBox/GreenCheckbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var areEqual;

var GenericRow = function GenericRow(props) {
  var myMap = (0, _RowComponents.mapMaker)(props.structure.headers, props.structure.dataKeys);

  if (props.structure.customMemoAreEqual) {
    areEqual = props.structure.customMemoAreEqual;
  }

  var fillRow = function fillRow(rowContent) {
    var filler = [];
    myMap.forEach(function (value, key) {
      var classes = 'cell';

      if (props.structure.rowFormat && props.structure.rowFormat[value] && props.structure.rowFormat[value].hasPriority) {
        classes = classes + ' priority';
      }

      if (props.structure.rowFormat && props.structure.rowFormat[value] && props.structure.rowFormat[value].format) {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: value,
          className: classes
        }, value && rowContent[value] && props.structure.rowFormat[value].format(rowContent[value]) || '-'));
      } else if (props.structure.rowFormat && props.structure.rowFormat[value] && props.structure.rowFormat[value].clickable) {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: key,
          className: classes
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "modalLink",
          data: rowContent[value],
          onClick: function onClick() {
            return props.structure.rowFormat[value].clickable(rowContent);
          }
        }, props.structure.rowFormat[value].name(rowContent[value]) || '-')));
      } else if (value) {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: key,
          className: classes
        }, value && rowContent[value] ? rowContent[value] : '-'));
      }
    });
    return filler;
  };

  var clickHandler = function clickHandler() {
    if (props.handleClick) {
      props.handleClick(props.id);
    }
  };

  var renderRow = function renderRow() {
    if (props.structure.hasSubRow) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "tableRow ".concat(props.isActive ? 'selected' : ''),
        onClick: clickHandler
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "primary"
      }, props.structure.hasIcon && /*#__PURE__*/_react["default"].createElement("img", {
        src: _right_arrow["default"],
        className: "rowButton ".concat(props.isActive ? 'down' : ''),
        alt: "row arrow"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "rowContent"
      }, true && fillRow(props.rowContent))), props.isActive && props.structure.hasSubRow && /*#__PURE__*/_react["default"].createElement("div", {
        className: "subMenu"
      }, renderSubMenu(props.rowContent.cooperator)));
    } else if (props.structure.isSelected) {
      var isChecked = props.structure.isSelected(props.rowContent);
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "generic_row",
        className: "tableRow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "primary"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkBox-container"
      }, /*#__PURE__*/_react["default"].createElement(_GreenCheckbox.GreenCheckbox, {
        checked: isChecked,
        onChange: function onChange() {
          return props.structure.toggleSelected(props.rowContent.reseller_id);
        },
        className: "checkbox"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "rowContent"
      }, props.rowContent && fillRow(props.rowContent))));
    } else {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "generic_row",
        className: "tableRow ".concat(props.isActive ? 'selected' : ''),
        onClick: clickHandler
      }, fillRow(props.rowContent));
    }
  };

  var renderSubMenu = function renderSubMenu(children) {
    return children.map(function (child, index) {
      return /*#__PURE__*/_react["default"].createElement(_GenericSubRow["default"], {
        key: index,
        index: index,
        rowContent: child,
        structure: props.subRowStructure
      });
    });
  };

  return renderRow();
};

exports.GenericRow = GenericRow;

var _default = /*#__PURE__*/_react["default"].memo(GenericRow, areEqual);

exports["default"] = _default;
GenericRow.propTypes = {
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  rowContent: _propTypes.object.isRequired,
  handleClick: _propTypes.func,
  isActive: _propTypes.bool,
  TrialPlanSubRow: _propTypes.object
};